import { Dialog } from 'construct-ui';
import paginationComponent from '../../../components/pagination/pagination.component';
import ViewBase from '../../view-base.view';
import DatePickerComponent from '../../../components/date-picker/date-picker.component';
import moment from 'moment';
import { formats as FORMATS } from '../../../config/constants';
import SingleSelectCommonComponentView from '../../../components/common/single-select-common-component.view';
import workTemplateModel from '../../../models/schedule/work-template.modal';
import teamApprovalModel from '../../../models/schedule/team-approval.modal';
import TeamApprovalDetailsView from './team-approval-details.view';
import TimePeriodView from './team-approval-time-period.view';
import multipleSelectListComponent from '../../../components/common/multiple-select-common.component';
import { workType } from '../../../models/schedule/team-schedule.model';
import MultiSelectComponent from '../../../components/multi-select/multi-select.component';
import SelectUserComponent from '../../../components/user/select-user.component';

export default function TeamApprovalView() {

  ViewBase.call(this);

  let inputDataModel = {
    data: [],
    workType: [],
    status: "001",
    statusList: [],
    workTypeList: [],
    iconList: [],
    fromDate: "",
    toDate: "",
    selectedUsers: [],
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0,
    selectedAttribute: []
  }

  let ddlStatus = {
    code: "001",
    name: "Pending Approval"
  }

  let dialogClass = "cui-dialog-xl";
  let enableControls = true;
  let fromInitDate;
  let toInitDate;
  let isDetailShow = false;
  let selectedItem;

  let _clearFilter = () => {
    inputDataModel.selectedAttribute = [];
    inputDataModel.selectedUsers = [];
    inputDataModel.workType = [];
    inputDataModel.status = "001";
    ddlStatus = { code: "001", name: "Pending Approval" };
    _initControls();
  }

  let _search = () => {
    inputDataModel.selectedAttribute = [];
    inputDataModel.pageIndex = 1;
    if (ddlStatus.code == "001") {
      enableControls = true;
    }
    else {
      enableControls = false;
    }
    _getPendingApprovals();
  }

  let _rowSelected = (item) => {
    if (item.leaveDayOffType != "002" && item.leaveDayOffType != "003") {
      dialogClass = "cui-dialog";
    } else {
      dialogClass = "cui-dialog-xl";
    }
    selectedItem = item;
    isDetailShow = true;
  }

  let _getPendingApprovals = () => {
    this.showLoading();
    return teamApprovalModel.getPendingApprovals(inputDataModel)
      .then((result) => {
        this.hideLoading();
        inputDataModel.data = result.data;
        inputDataModel.totalCount = result.total;
        inputDataModel.pageIndex = result.pageIndex;
        inputDataModel.pageSize = result.pageSize;
      })
      .catch((error) => {
        this.hideLoading();
        this.handleError(error);
      });
  }

  let _initControls = () => {
    _loadWorkTypeList();
    _loadStatusList();
    fromInitDate = moment(new Date()).format(FORMATS.dateFormat);
    toInitDate = moment(new Date()).format(FORMATS.dateFormat);
    inputDataModel.fromDate = moment(new Date()).format(FORMATS.apiDateFormat);
    inputDataModel.toDate = moment(new Date()).format(FORMATS.apiDateFormat);
    _getPendingApprovals();

  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    inputDataModel.pageIndex = pageIndex;
    inputDataModel.pageSize = pageSize;
    _getPendingApprovals();
  }

  let onPageChanged = (pageIndex) => {
    inputDataModel.pageIndex = pageIndex;
    _getPendingApprovals();
  }

  let _onDatePickerChange = (e) => {
    fromInitDate = moment(e.detail.start).format(FORMATS.dateFormat);
    toInitDate = moment(e.detail.end).format(FORMATS.dateFormat);
    inputDataModel.fromDate = moment(e.detail.start).format(FORMATS.apiDateFormat);
    inputDataModel.toDate = moment(e.detail.end).format(FORMATS.apiDateFormat);
  }

  let _onDetailClose = () => {
    isDetailShow = false;
  }

  let _loadStatusList = () => {
    inputDataModel.workType = [];
    return teamApprovalModel.getStatusList()
      .then((result) => {
        inputDataModel.status = "001";
        inputDataModel.statusList = result;
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  let _loadWorkTypeList = () => {
    inputDataModel.workType = [];
    workTemplateModel.getWorkTypeList(
      (result) => {
        inputDataModel.workTypeList = result;
      },
      (error) => {
        this.hideLoading();
        this.handleError(error);
      }
    )
  }

  function isChecked(scheduleApprovalID) {
    const ic = inputDataModel.selectedAttribute.findIndex(x => x.scheduleApprovalID == scheduleApprovalID) > -1;
    return ic;
  }

  function removeSelectedAttribute(detail, target) {
    if (target.checked) {
      inputDataModel.selectedAttribute.push(detail);
    }
    else {
      inputDataModel.selectedAttribute = inputDataModel.selectedAttribute.filter(x => x.scheduleApprovalID != detail.scheduleApprovalID);

    }
  }

  let _save = (status) => {
    this.showLoading();
    let idArr = [];
    if (inputDataModel.selectedAttribute.length > 0) {
      inputDataModel.selectedAttribute.forEach(function (item) {
        idArr.push(item.scheduleApprovalID);
      });
      teamApprovalModel.changeStatusList(status, idArr)
        .then((result) => {
          this.hideLoading();
          this.showMessage(result[0].transStatus, this.getText(result[0].code));
          _getPendingApprovals();
        })
        .catch((error) => {
          this.hideLoading();
          this.handleError(error);
        });
    } else {
      this.hideLoading();
      this.showErrorMessage(
        this.getText("EM00000277", "Please select an item"),
        this.getText("EM00000142", "Error")
      )
    }
  }

  let _onDetailSave = (result) => {
    isDetailShow = false;
    this.showMessage(
      this.getText(result[0].message),
      result[0].transStatus,
    );
    _getPendingApprovals();
  }

  return {
    oninit: (vnode) => {
      _initControls();
    },
    view: (vnode) => {
      return [
        m('.row',
          m('.col-12',
            // Search section
            m('.card.mb-3',
              m('.card-body',
                m('.row.g-4',
                  m('.col-md-3',
                    m('label.form-label', this.getText("LT00000070", "Date Range")),
                    m(DatePickerComponent, {
                      class: 'form-control',
                      isRange: true,
                      dateStart: fromInitDate, // default date range
                      dateEnd: toInitDate, // default date range
                      onselect: (e) => {
                        _onDatePickerChange(e);
                      }
                    })
                  ),
                  m('.col-md-3',
                    m('label.form-label', this.getText("LT00000149", "Work Type")
                    ),
                    m(multipleSelectListComponent, {
                      colorList: workType.WORK_TYPES, items: inputDataModel.workTypeList, selectedList: inputDataModel.workType, handleSelect: (selectedList) => {
                        inputDataModel.workType = selectedList;
                      }
                    })
                  ),
                  m('.col-md-3',
                    m('label.form-label', this.getText("LT00000009", "User")),
                    m(SelectUserComponent, {
                      default: {
                        userStatusCode: '0001'
                      },
                      onSelect: (u) => {
                        inputDataModel.selectedUsers = u;
                      },
                      selectedUserList: inputDataModel.selectedUsers,
                    })
                  ),
                  m('.col-md-3',
                    m('label.form-label', this.getText("LT00000015", "Status")),
                    m(SingleSelectCommonComponentView, {
                      disabled: false, iconList: [], items: inputDataModel.statusList, selectedItem: ddlStatus, handleSelect: (selectedItem) => {
                        ddlStatus = selectedItem;
                        inputDataModel.status = selectedItem.code;
                      }
                    })
                    // TODO: Change to this when the API to support multiple status is ready
                    // statusList &&
                    // m(MultiSelectComponent, {
                    //   items: statusList,
                    //   onSelect: (selectedOptions) => {
                    //     // selectedWorkTypeList = selectedOptions.map(o => o.code);
                    //   }
                    // })
                  ),
                  m('.col-12.gap-2.d-flex.justify-content-end',
                    m('button.btn.btn-primary.px-4.gap-3', { onclick: _search }, this.getText("LT00000001", "Search")),
                    m('button.btn.btn-white.px-4.gap-3', { onclick: _clearFilter }, this.getText("LT00000031", "Clear")),
                  ),
                )
              )
            ),
            m('.card',
              m('.card-body',
                enableControls &&
                m('.d-flex.justify-content-end.mb-2',
                  m('a.btn.btn-primary', { onclick: () => { _save('A') } },
                    m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000185", "Approve"),
                  )
                ),
                m('.row',
                  m(".col-12.p-0",
                    m(".table-responsive",
                      m("table.table",
                        [
                          m("thead.thead-bggrey",
                            m("tr.align-middle",
                              [
                                enableControls && m("th", { "scope": "col" }, ""),
                                m("th", { "scope": "col" }, this.getText("LT00000132", "Date")),
                                m("th", { "scope": "col" }, this.getText("LT00000181", "Schedule Time")),
                                m("th", { "scope": "col" }, this.getText("LT00000049", "User ID")),
                                m("th", { "scope": "col" }, this.getText("LT00000117", "Type")),
                                m("th", { "scope": "col" }, this.getText("LT00000071", "Site") + '/' + this.getText("LT00000367", "Sub-category")),
                                m("th", { "scope": "col" }, this.getText("LT00000015", "Status")),
                                m("th", { "scope": "col" }, this.getText("LT00000152", "Remarks"))
                              ])
                          ),
                          m("tbody",
                            inputDataModel.data.length == 0 &&
                            m("tr", { "class": "align-middle" },
                              m("td", { "colspan": "8" }, this.getText("EM00000141", "No records found."))
                            ),
                            inputDataModel.data.map(gc =>
                              [
                                m("tr.rowSelect",
                                  [

                                    enableControls && m("td", m('div.form-check',
                                      (gc.leaveDayOffType != "002" && gc.leaveDayOffType != "003" && gc.scheduleApprovalType == '001' && moment(gc.scheduleDate) > moment(new Date())) && m('input[class="form-check-input"][type="checkbox"]', {
                                        checked: isChecked(gc.scheduleApprovalID),
                                        onclick: (e) => {
                                          removeSelectedAttribute(gc, e.target)
                                        }
                                      }
                                      )
                                    )),
                                    m("td", { onclick: () => { _rowSelected(gc) } }, gc.scheduleDateFormat),
                                    m("td", { onclick: () => { _rowSelected(gc) } }, m(TimePeriodView, { data: gc })),// gc.startTime !=null ? m('span',gc.startTime + ' ~ ' + gc.endTime ):m('span','-'),gc.breakHour !=null ? m('span',' (' + gc.breakHour + ' hr)'):m('span','')),
                                    m("td", { onclick: () => { _rowSelected(gc) } }, gc.userID),
                                    m("td", { onclick: () => { _rowSelected(gc) } }, gc.workTypeName),
                                    m("td", { onclick: () => { _rowSelected(gc) } },
                                      (gc.workType == "001") && gc.siteName,
                                      (gc.workType == "002" || gc.workType == "003" || gc.workType == "007") && gc.leaveDayOffTypeName
                                    ),
                                    m("td", gc.scheduleApprovalType == "001" && m('.badge.rounded-pill.pending-bg-status', gc.scheduleApprovalTypeName),
                                      gc.scheduleApprovalType == "002" && m('.badge.rounded-pill.green-bg-status', gc.scheduleApprovalTypeName),
                                      gc.scheduleApprovalType == "003" && m('.badge.rounded-pill.danger-bg-status', gc.scheduleApprovalTypeName),
                                      gc.scheduleApprovalType == "004" && m('.badge.rounded-pill.cancelled-bg-status', gc.scheduleApprovalTypeName),
                                      gc.scheduleApprovalType == "005" && m('.badge.rounded-pill.grey-bg-status', gc.scheduleApprovalTypeName),
                                    ),
                                    m("td", { onclick: () => { _rowSelected(gc) } }, gc.remarks),
                                  ])
                              ]
                            ),
                          )
                        ]
                      ),
                    ),
                    m(".px-3",
                      m(paginationComponent, { currentPage: inputDataModel.pageIndex, pageSize: inputDataModel.pageSize, totalItems: inputDataModel.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                    )
                  )
                )
              ),
            )
          ),
          m(Dialog, {
            isOpen: isDetailShow,
            transitionDuration: 200,
            closeOnOutsideClick: false,
            onClose: () => { isDetailShow = false; },
            title: this.getText("LT00000108", "Details"),
            content: m(TeamApprovalDetailsView, { item: selectedItem, onClosed: _onDetailClose, onSaved: _onDetailSave }),
            "class": dialogClass
          }),
        ),
        this.getBaseViews()
      ]
    }
  }
}
